module.exports = __webpack_public_path__ + "static/media/iPhone14_6.b8606ace.png";